import { render, staticRenderFns } from "./waiver.vue?vue&type=template&id=06c871ba&"
import script from "./waiver.vue?vue&type=script&lang=js&"
export * from "./waiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports